// extracted by mini-css-extract-plugin
module.exports = {"container":"_2r5du0ozVszBfxBd8ubfx","emojiPickerButton":"_3t4YKjFlvX0Soxj7fr0dpl","emojiPickerContainer":"_2UIGQh0WNi9RTKEzqSkBmW"};